import React, { Component } from "react";
import { connect } from "react-redux";
import * as auth from "../../actions";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { mapErrorToField } from "../../utils";
import { Button, Toast } from "react-bootstrap";
import { SpinnerContext } from "../../components/spinner/spinner.component";
import cancleImg from "../../assets/images/cancle.svg";
import infoIcon from "../../assets/images/info-24px.svg";
import { STORAGE } from "../../constants/storage.constant";
import { Tooltip } from "../../components/button/tool-tip.component";
import {getStorage,removeStorage,setStorage} from "../../utils/storage.util";
import { encryptData, decryptData } from "../../utils/crypto.util";


const MyContext = React.createContext();
class Login extends Component {
  static contextType = SpinnerContext;
  loginSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is Required"),
    password: Yup.string().required("Password is required"),
    rememberMe: Yup.boolean(),
  });

  constructor(props) {
    super(props);
    const storedEmail = getStorage(STORAGE.REMEMBER_ME_KEY);
     this.onLogin = this.onLogin.bind(this);
    this.state = {
      forgotShow: false,
      showError: false,
      signInModalShow: false,
      initialEmail: storedEmail ? decryptData(storedEmail) : "",
    };
  }

  showForm = ({
    values,
    handleChange,
    handleSubmit,
    isSubmitting,
    }) => {
    const showForgot = () => {
      this.setState({ forgotShow: true });
      this.loginSchema.fields.password = Yup.string().notRequired();
    };

    return (
      <div className="login-wrapper">
        <div className="modal-header">
          <div className="login-modal-header" onClick={this.props.onHide}>
            <img
              src={cancleImg}
              className="img-fluid"
              alt="cancleImg"
              style={{ cursor: "pointer" }}
            />
          </div>
          {this.state.forgotShow ? (
            <>
              <h5 className="modal-title" id="">
                Forgot password?
              </h5>
              <p>Please enter your email to receive password</p>
            </>
          ) : (
            <>
              <h5 className="modal-title" id="">
                Sign In
              </h5>
              <p className="mb-0">Sign in to your account</p>
            </>
          )}
        </div>
        <div className="modal-body p-0">
          <Toast
            onClose={() => this.showError(false)}
            show={this.state.showError}
            delay={3000}
            autohide
            className="list-group-item-warning"
          >
            <Toast.Body>
              <ul>
                {this.props.error &&
                  this.props.error.data.map(function (item) {
                    return <li key={item}>{item}</li>;
                  })}
              </ul>
            </Toast.Body>
          </Toast>
          <Form onSubmit={handleSubmit}>
            <div className="authentication">
              <div className="form-group mb-0 pb-lg-1">
                <Field
                  type="email"
                  name="email"
                  className="form-control mt-0 mb-2"
                  onChange={handleChange}
                  value={values.email}
                  placeholder="Email"
                  required
                />
              </div>
              {!this.state.forgotShow && (
                <div>
                  <div className="form-group mb-0 pb-lg-1">
                    <Field
                      type="password"
                      name="password"
                      onChange={handleChange}
                      value={values.password}
                      placeholder="Password"
                      className="form-control mt-0 mb-2"
                      required
                    />
                  </div>

                  <div className="password-options-container">
                    <div className="remember-me">
                      <label>
                        <Field type="checkbox" name="rememberMe" />
                        Remember Me
                      </label>
                      <Tooltip message="For security reasons, the system only remembers your email, not your password, as per HIPAA compliance.">
                        <span className="info-icon">
                          <img
                            src={infoIcon}
                            alt="Information"
                            style={{ width: "16px", height: "16px" }}
                          />
                        </span>
                      </Tooltip>
                    </div>

                    <div className="forgot-pass">
                      <a href="#" role="button" onClick={showForgot}>
                      Forgot password?&nbsp;
                      </a>
                    </div>
                  </div>
                </div>
              )}
              <div className="action-btn my-4 py-2">
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-primary"
                  size="lg"
                  block
                >
                  {!this.state.forgotShow ? " Sign In" : " Send Email"}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        <div>
          <Formik
            initialValues={{
              email: this.state.initialEmail,
              password: "",
              general: "",
              rememberMe: true, //default value for rememberMe
            }}
            onSubmit={this.onLogin}
            validationSchema={this.loginSchema}
          >
            {(props) => this.showForm(props)}
          </Formik>
        </div>
        <div className="extra-link">
          Not registered yet?&nbsp;
          <a role="button" onClick={this.props.onRegistration}>
            {" "}
            Sign Up
          </a>
        </div>
      </div>
    );
  }

  onLogin = async (values, {props, setErrors, setSubmitting }) => {
    const handleStorage = () => {
      if (values.rememberMe) {
        setStorage(STORAGE.REMEMBER_ME_KEY, encryptData(values.email), 30 * 24 * 60 * 60);

      } else {
        removeStorage(STORAGE.REMEMBER_ME_KEY);
      }
    };

    const submissions = [];
    let message = "Signing in";

    if (this.state.forgotShow) {
      message = "Sending an email";
      submissions.push(this.props.forgotPassword(values.email));
    } else {
      submissions.push(this.props.login(values.email, values.password));
    }

    this.context.showLoader(message);

    try {
      await Promise.all(submissions);
      handleStorage();
      // Corrected timeout usage
       setTimeout(this.props.registerDevice, this.props.sessionLogout(), 10);
    } catch (error) {
      removeStorage(STORAGE.REMEMBER_ME_KEY);
      this.showError(true);
      setErrors(mapErrorToField(this.props.error));
      setSubmitting(false);
    } finally {
      this.context.hideLoader();
    }
  };

  showError = (value) => this.setState({ showError: value });
}

export default connect(
  ({ auth }) => ({ error: auth.error }),
  auth.authAction
)(Login);
